import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DialogComponent } from "../components/DialogOutlet";
import { RootState } from "../store";

export interface DialogsState {
    componentList: DialogComponent[];
}

const initialState: DialogsState = {
    componentList: [],
};

let nextId = 0;
export const dialogsSlice = createSlice({
    name: "dialogs",
    initialState,
    reducers: {
        create: (state, action: PayloadAction<DialogComponent>) => {
            action.payload.id = nextId++;
            action.payload.props.dialogId = action.payload.id;
            state.componentList.push(action.payload);
        },
        dismiss: (state, action: PayloadAction<number>) => {
            state.componentList = state.componentList.filter((dc) => dc.id !== action.payload);
        },
    },
});

export const { create, dismiss } = dialogsSlice.actions;

export const selectDialogComponentList = (state: RootState) => state.dialogs;
export default dialogsSlice.reducer;
